export default __webpack_public_path__ + "static/staffpass-2-a4dd54e8aa69fff53db0cab707155e36.png";